import { Column } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import styled, { css } from "styled-components";

export const ShowAllContainer = styled.div`
  position: absolute;
  align-items: center;
  justify-items: center;
  bottom: 0;
  right: 0;
  margin: ${getSpacing("2x")};

  ${responsiveMediaQueries.mobile} {
    display: none;
  }
`;

export const ImageGridView = styled.div<{
  $mediaTotal: number;
}>`
  ${responsiveMediaQueries.mobile} {
    width: 100%;
    height: 100vw;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    margin-bottom: ${getSpacing("2x")};
  }

  ${responsiveMediaQueries.tabletAndAbove} {
    grid-template-columns: auto auto;
    grid-template-rows: auto auto auto;
    display: grid;
    grid-gap: 4px;
    align-items: start;
    ${(props) => {
      if (props.$mediaTotal < 3) {
        return css`
          grid-template-areas:
            "media-0 media-0"
            "media-1 media-1"
            ". .";
        `;
      } else if (props.$mediaTotal === 3) {
        return css`
          grid-template-areas:
            "media-0 media-0"
            "media-1 media-2"
            ". .";
        `;
      } else if (props.$mediaTotal === 4) {
        return css`
          grid-template-areas:
            "media-0 media-0"
            "media-1 media-2"
            "media-3 media-3";
        `;
      } else if (props.$mediaTotal === 5) {
        return css`
          grid-template-areas:
            "media-0 media-0"
            "media-1 media-2"
            "media-3 media-4";
        `;
      } else {
        return css`
          grid-template-rows: auto auto auto auto;
          grid-template-areas:
            "media-0 media-0"
            "media-1 media-2"
            "media-3 media-4"
            "media-5 media-5";
        `;
      }
    }}
  }
  ${responsiveMediaQueries.desktopAndAbove} {
    ${(props) => {
      if (props.$mediaTotal < 3) {
        return css`
          grid-template-areas:
            "media-0 media-0"
            "media-1 media-1"
            ". .";
        `;
      } else if (props.$mediaTotal === 3) {
        return css`
          grid-template-areas:
            "media-0 media-0"
            "media-1 media-2"
            ". .";
        `;
      } else if (props.$mediaTotal === 4) {
        return css`
          grid-template-areas:
            "media-0 media-1"
            "media-2 media-3"
            ". .";
        `;
      } else if (props.$mediaTotal === 5) {
        return css`
          grid-template-areas:
            "media-0 media-1"
            "media-2 media-3"
            "media-4 .";
        `;
      } else {
        return css`
          grid-template-areas:
            "media-0 media-1"
            "media-2 media-3"
            "media-4 media-5";
        `;
      }
    }}
  }
`;

// FD-40040: PageLoader will always show up before content renders, which
// results in the scroll history not being preserved. We want to set a reasonable
// base height on this page to preserve the scroll position if possible.
// height is an approximation using: ProductContent, More From Brand, Similar Products,
// and Brand Reviews.
export const LoadingContainer = styled(Column).attrs({ justify: "flex-start" })`
  position: relative;
  width: 100%;

  height: 2000px;

  ${responsiveMediaQueries.tabletAndAbove} {
    height: 2250px;
  }
`;
LoadingContainer.displayName = "LoadingContainer";
